import { useContext } from 'react';
import './CreateTodoButton.css';
import { TodoContext } from '../../TodoContext';

function CreateTodoButton({ onClick }) {
  const {setOpenModal} = useContext(TodoContext);

  return (
    <div className='CreateTodoButton'>
      <button className="CreateButton" onClick={() => setOpenModal(prevState => !prevState)}>Add To-Do</button>
    </div>
  )
}

export { CreateTodoButton };